import React, { useState } from "react";
import { Flex, Card, Title } from "@mantine/core";

import {
  BulkLocationDownload,
  LocationForm,
  LocationList,
} from "@components/Location";
import { ManagementLayout } from "@components/shared";

export default function LocationIndex() {
  const [refresh, setRefresh] = useState(false);

  return (
    <ManagementLayout
      dataComponent={<LocationList isIndex refresh={refresh} />}
      createComponent={
        <Card
          style={{
            overflow: "visible",
          }}
        >
          <Title order={4}>Create Location</Title>
          <LocationForm onSuccess={() => setRefresh(!refresh)} />
          <Flex justify="center" mt="lg">
            <BulkLocationDownload
              downloadReqData={{
                context: "location_index",
              }}
            />
          </Flex>
        </Card>
      }
    />
  );
}
